export default "__VITE_ASSET__CR9Vyyc4__"